import { Injectable } from '@angular/core';
import { differenceInMinutes, formatDistance } from 'date-fns';
import { fr } from 'date-fns/locale';
import moment_ from 'moment';
const moment = moment_;
@Injectable({
  providedIn: 'root',
})
export class HealthSignatureService {
  constructor() {}

  remaining(signatureReady: any): string {
    let date = moment().utc().toISOString();
    return formatDistance(signatureReady, date, {
      locale: fr,
      includeSeconds: true,
    });
  }

  remaining2(signatureReady: any): number {
    let dateUtc = moment().utc().toDate();
    let dateRight = moment(signatureReady).toDate();
    let number = differenceInMinutes(dateRight, dateUtc);
    return number;
  }
}
